import { render, staticRenderFns } from "./SettingsTabPlugins.vue?vue&type=template&id=884b9fbc"
import script from "./SettingsTabPlugins.vue?vue&type=script&lang=js"
export * from "./SettingsTabPlugins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports